import {Component, Vue} from 'vue-property-decorator';
import MenuItem from '@/models/MenuItem';
import {findAll} from '@/repositories/local/MenuItemLocal';
import SecurityModule from '@/store/modules/SecurityModule';

@Component
export class MenuMixin extends Vue {
  public menuItems: MenuItem[] = findAll();

  public haveAccess(menuItem: MenuItem): boolean {
    const user = SecurityModule.getUser;

    if (menuItem.role === undefined) {
      return true;
    } else {
      if (user) {
        return  user.roles.includes(menuItem.role!!);
      } else {
        return false;
      }
    }
 }

  public isSelect(menuItem: MenuItem): boolean {

    return menuItem.activeRoutes.includes(this.$route.name as string) || this.isChildSelected(menuItem);
  }

  public isChildSelected(menuItem: MenuItem): boolean {
    let isChildSelected = false;

    menuItem.children.forEach(
      (menuItemChild) => {
        if (menuItemChild.activeRoutes.includes(this.$route.name as string)) {
          isChildSelected = true;
        }
      },
    );

    return isChildSelected;
  }
}
